import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, Link } from "react-router-dom";

import { SecondOpinionFormTypes } from "../../constants";
import {
  getSecondOpinionForm_Ajax,
  getStates_Ajax
} from "../../helpers/requests";
import {
  handleApiErrors,
  showConfirmDialouge,
  queryStringToJSON,
  initializeAdditionalChangesInFormIoFormDuringRender
} from "../../helpers/utils";
import { saveSecondOpinionRecordRequestProgress } from "../../indexedDbHelper/secondOpinionRecordRequestProgressIndexedDbHelper";
import {
  hideLoadingSpinner,
  showLoadingSpinner
} from "../../redux/actions/loadingSpinner";
import QuestionnaireTabs from "../QuestionnaireTabs/QuestionnaireTabs";

import { Form } from "@formio/react";
import "formiojs/dist/formio.full.min.css";

const QuestionnaireIntakeFormPage = (props) => {
  const { patientId, savedProgress } = props;

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const clientName = useSelector(
    (state) => state?.appSettings?.settingsData?.clientName
  );

  const [secondOpinionForm, setSecondOpinionForm] = useState(null);
  const [currentFormIndex, setCurrentFormIndex] = useState(0);
  const [totalForms, setTotalForms] = useState(0);
  const [patientState, setPatientState] = useState(null);
  const [displayFormData, setDisplayFormData] = useState(null);
  const [states, setStates] = useState([]);
  const [includeZState, setIncludeZState] = useState(false);
  const [submissionData, setSubmissionData] = useState();

  useEffect(() => {
    if (savedProgress?.patientState) {
      setPatientState(savedProgress.patientState);
    }
    if (savedProgress?.secondOpinionForm?.formData) {
      setSubmissionData(savedProgress.secondOpinionForm.formData);
    }
  }, [savedProgress]);

  useEffect(() => {
    let params = queryStringToJSON();
    let includeZState = false;
    if (params.includezstate) {
      if (params.includezstate == "true") {
        includeZState = true;
      }
    }
    setIncludeZState(includeZState);
  }, []);

  useEffect(() => {
    getStates("US");
    getSecondOpinionForm();
  }, []);

  useEffect(() => {
    if (secondOpinionForm) {
      var formData = {};
      var formArray = JSON.parse(secondOpinionForm.formComponent);

      var formObj = {
        display: "form",
        components: formArray
      };

      var submissionData = {};
      var formOptions = {};

      if (secondOpinionForm.formData) {
        submissionData = {
          data: secondOpinionForm.formData
        };

        var formOptions = {
          readOnly: true,
          viewAsHtml: true
        };
      }

      formData.formObj = formObj;
      formData.submissionData = submissionData;
      formData.formOptions = formOptions;

      setDisplayFormData(formData);

      if (isFormSubmitted()) {
        saveBtnClicked();
      }
    }
  }, [secondOpinionForm]);

  function getStates(countryCode) {
    if (countryCode) {
      getStates_Ajax(
        countryCode,
        function (response) {
          if (response && response.success && response.data) {
            setStates(response.data);
          }
        },
        function (err) {
          handleApiErrors(err);
        }
      );
    }
  }

  function onFormSubmit(submission) {
    setTimeout(function () {
      if (submission && submission.data) {
        onSuccessfulFormSubmission(submission.data);
      }
    }, 500);
  }

  function onSuccessfulFormSubmission(submissionData) {
    if (submissionData && secondOpinionForm) {
      var secondOpinionFormData = { ...secondOpinionForm };
      secondOpinionFormData.isSubmitted = true;
      secondOpinionFormData.formData = submissionData;

      setSecondOpinionForm(secondOpinionFormData);
    }
  }

  function isFormSubmitted() {
    return secondOpinionForm && secondOpinionForm.isSubmitted;
  }

  function isStateSelected() {
    return patientState && patientState != null;
  }

  function prepareAndSetSecondOpinionForm(form) {
    if (form) {
      let customFormTitle = "Second Opinion Intake Form";
      let formObj = {
        title: customFormTitle,
        formComponent: form.medicalForm?.components,
        medicalFormId: form.formId,
        isSubmitted: false
      };

      setSecondOpinionForm(formObj);
    }
  }

  function getSecondOpinionForm() {
    var params = {
      clientName: clientName
    };

    dispatch(showLoadingSpinner());
    getSecondOpinionForm_Ajax(
      SecondOpinionFormTypes.IntakeForm,
      params,
      function (response) {
        dispatch(hideLoadingSpinner());
        if (
          response &&
          response.success &&
          response.data &&
          response.data.secondOpinionForm
        ) {
          prepareAndSetSecondOpinionForm(response.data.secondOpinionForm);
        }
      },
      function (err) {
        dispatch(hideLoadingSpinner());
        handleApiErrors(err);
      }
    );
  }

  function saveBtnClicked() {
    let curState = {
      ...savedProgress,
      patientState,
      secondOpinionForm,
      patientId
    };
    saveSecondOpinionRecordRequestProgress(curState, patientId);

    navigate(
      includeZState
        ? "/questionnaire-review-submit?includeZState=true"
        : "/questionnaire-review-submit",
      {
        state: curState
      }
    );
  }

  function cancelBtnClicked() {
    showConfirmDialouge(
      "Are you sure?",
      "You have unsaved changes, are you sure that you want to cancel? All of your changes will be lost.",
      function () {
        navigate("/record-request");
      }
    );
  }

  return (
    <>
      <div className="container">
        <div className="row">
          <div className="col-sm-12">
            <div className="bg-white border-radius-xlg px-4 px-md-5 py-4">
              <QuestionnaireTabs />
              <div className="form-group mb-3 col-md-6">
                <label className="form-label text-align-left">
                  Select your current state
                </label>
                <select
                  className="form-select form-control"
                  name="state"
                  id="state"
                  value={patientState}
                  onChange={(event) => setPatientState(event.target.value)}
                >
                  <option key={0} value="">
                    Select States
                  </option>
                  {states.map((state, index) => {
                    return (
                      <option key={index + 1} value={state?.value}>
                        {state.name}
                      </option>
                    );
                  })}
                </select>
              </div>
              {displayFormData && isStateSelected() ? (
                <div id="campaign-form">
                  <div className="campaign-form-container text-align-left">
                    <h3 className="fs-1 mb-0">{secondOpinionForm.title}</h3>
                    <Form
                      onRender={
                        initializeAdditionalChangesInFormIoFormDuringRender
                      }
                      key={"displayed_" + currentFormIndex}
                      form={displayFormData.formObj}
                      submission={{ data: submissionData }}
                      onSubmit={onFormSubmit}
                    />
                  </div>
                </div>
              ) : (
                <></>
              )}
              <div className="form-group text-center mt-3 mt-md-5 col-sm-12 button-wrapper">
                <button
                  onClick={cancelBtnClicked}
                  className="btn btn-outline btn-rounded btn-lg px-5 mx-md-2 mt-3 mt-md-0 w-100 w-md-auto"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default QuestionnaireIntakeFormPage;
